module.exports = __webpack_public_path__ + "static/media/instagram.fc23b902.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instagram.svg
// module id = 17
// module chunks = 0